@if (shouldRender()) {
<section class="block-offers">
  <div class="block-offers__inner">
    <app-product-carousel
      title="Ofertas"
      viewAllLink="/tienda"
      [viewAllQueryParams]="{ on_discount: true }"
      [products]="products()"
      [arrowsOnHover]="true"
      [showPagination]="true"
      (addToCart)="addToCart.emit($event)"
      (zoomOpen)="zoomOpen.emit($event)"
      (notifyRequest)="notifyRequest.emit($event)"
      (notifyCancel)="notifyCancel.emit($event)"
      (cardClick)="cardClick.emit($event)"
      (reserveClick)="reserveClick.emit($event)"
    />
  </div>
</section>
}
